import axios from 'axios'
import * as commonActions from '../../common.actions'
import getApiUrl from '../../helpers/api-urls'
import { cacheManager } from 'helpers/util-common'

export const getFeatureFlag = (dispatch) => {
	const url = `${getApiUrl('featureFlag', 'getfeatureFlag')}`
	dispatch(commonActions.setLoader(true))
	axios.get(url)
		.then(response => {
			dispatch(commonActions.setLoader(false))
			if (response?.data?.Status && response?.data?.Result) {
				cacheManager.setItem("flagFeature", response.data.Result)
                dispatch(commonActions.setFeatureFlag(true))
			}
			else {
				dispatch(commonActions.setMessage(true, '400'))
                dispatch(commonActions.setFeatureFlag(false))
			}
		})
		.catch(() => {
			dispatch(commonActions.setMessage(true, '400'))
			dispatch(commonActions.setLoader(false))
            dispatch(commonActions.setFeatureFlag(false))
		})
}
